import { Col, Row } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import OrdersTable from '../../components/OrdersTable';

import Header from '../../components/Header';
import { Link } from 'react-router-dom';
import { useGetLoggedInUserQuery } from '../../redux/api/users';
import { isInternalOrdersManager } from '../../utils/isInternalOrdersManager';

function FastlaneOrders() {
	const { data: loggedInUser, isLoading: isLoadingUser } = useGetLoggedInUserQuery();
	const canManageInternalOrders = isInternalOrdersManager(loggedInUser);

	return (
		<>
			<Header
				title="Orders"
				breadcrumbItems={[
					{
						title: <Link to="/">Home</Link>,
					},
					{
						title: 'Orders',
					},
				]}
				// Deliberately hidden (not just disabled) while the permission check
				// is in flight, rather than showing it and yanking it away a moment
				// later for a non-manager -- a hidden-by-permission button always has
				// some absence→presence flash for a real manager on first paint; this
				// just makes sure the reverse (presence→absence) never happens too.
				showLinkButton={!isLoadingUser && canManageInternalOrders}
				link="/orders/internal/add"
				buttonText="Internal Order"
				icon={<PlusOutlined />}
			/>
			<Row>
				<Col span={24}>
					<OrdersTable />
				</Col>
			</Row>
		</>
	);
}

export default FastlaneOrders;
